/**
 * Money formatting.
 *
 * Currency comes from the PLAN, never a hardcoded symbol. Custom contracts are
 * priced in INR or USD, so `currency === "USD" ? "$" : ""` renders an Indian
 * contract as a bare number with no symbol at all — which is how ₹60,000 and
 * $60,000 become indistinguishable on the one screen where that matters.
 *
 * Intl also gets the conventions right per locale: ₹60,000.00 groups digits
 * differently from $60,000.00 in some locales, and we should not be
 * reimplementing that.
 */
export function formatMoney(cents: number, currency: string): string {
	try {
		return new Intl.NumberFormat(undefined, {
			style: "currency",
			currency,
			minimumFractionDigits: 2,
		}).format(cents / 100);
	} catch {
		// An unknown currency code must not blank the screen — show the number
		// with the code beside it rather than nothing.
		return `${(cents / 100).toFixed(2)} ${currency}`;
	}
}

/** "quarterly" -> "quarter", so prices read "per quarter" not "per quarterly". */
export function cycleNoun(cycle: string | undefined): string {
	switch (cycle) {
		case "monthly":
			return "month";
		case "quarterly":
			return "quarter";
		case "annual":
			return "year";
		default:
			return cycle ?? "cycle";
	}
}
